import { render } from "./preguntasFrecuentes.vue?vue&type=template&id=3addd5f6"
import script from "./preguntasFrecuentes.vue?vue&type=script&lang=js"
export * from "./preguntasFrecuentes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__